const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16
  }),
  buttonBase: {
    display: "block",
    marginBottom: 16,
    paddingBottom: 8
  },
  button: {
    margin: theme.spacing.unit,
    background: theme.palette.accent,
    color: "white",
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  downloadButton: {
    padding: 0,
    minWidth: "initial",
    backgroundColor: "initial!important",
    color: "initial!important"
  },
  zip_icon: {
    height: "80%",
    width: "80%"
  }
});

export default styles;
